import Vue from 'vue'
import Ionic from '@ionic/vue'
import '@ionic/core/css/ionic.bundle.css'
import { defineCustomElements } from '@ionic/pwa-elements/loader'
Ionic.install(Vue, { mode: 'ios' })
defineCustomElements(window)
